module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/settings-1-bd80ed1fa3e13bd424545a3f02051c22.svg";